// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"70f7bf60","239":"46be9732","455":"aada0e6b"}[chunkId] + ".chunk.js";
};